module.exports = __webpack_public_path__ + "img/bg10.8294625c.png";